import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export enum ActionType {
  Editar = 'EDITAR',
  Remover_Especialidades = 'REMOVER_ESPECIALIDADES',
  Remover_Empresa = 'REMOVER_EMPRESA',
  Remover_All = 'REMOVER_ALL',
}

export const vinculoSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object({
    action: Yup.string().required(),

    especialidades: Yup.array().when('action', {
      is: (val: ActionType) =>
        val === ActionType.Editar || val === ActionType.Remover_Especialidades,
      then: (schema) => schema.min(1, v.requiredField('especialidade', 'array')),
      otherwise: (schema) => schema.notRequired(),
    }),

    empresa: Yup.object()
      .nullable()
      .when('action', {
        is: (val: ActionType) => val === ActionType.Editar || val === ActionType.Remover_Empresa,
        then: (schema) => schema.required(v.requiredField('empresa', 'select')),
        otherwise: (schema) => schema.nullable(),
      }),
  })
}
